export const getOffset = function (el) {
  const rect = el.getBoundingClientRect();
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY
  };
};
export const hasSomeParentTheClass = function (element, classname) {
  if (element.className.split(' ').indexOf(classname) >= 0) return true;
  return element.parentNode && hasSomeParentTheClass(element.parentNode, classname);
};
export const resetHeight = $elements => {
  $elements.forEach($el => {
    $el.style.height = 'auto';
  });
};
export const maxHeight = function ($elements) {
  let resHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!$elements) return;
  if (resHeight) resetHeight($elements);
  const max = Math.max.apply(null, [...$elements].map($el => $el.offsetHeight));
  $elements.forEach($el => {
    $el.style.height = `${max}px`;
  });
};
export const minHeight = function ($elements) {
  let resHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!$elements) return;
  if (resHeight) resetHeight($elements);
  const min = Math.min.apply(null, [...$elements].map($el => $el.offsetHeight));
  $elements.forEach($el => {
    $el.style.height = `${min}px`;
  });
};
export const formatBytes = function (bytes) {
  let decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  // eslint-disable-next-line no-mixed-operators
  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
};
export const createEl = function () {
  let tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let content = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  const $el = document.createElement(tag);
  Object.keys(attributes).forEach(attr => {
    $el.setAttribute(attr, attributes[attr]);
  });
  $el.innerHTML = content;
  return $el;
};
export const arrayEquals = (a, b) => Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index) => val === b[index]);
export const isTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
export const dispatchEvent = function (element, eventName) {
  if ('createEvent' in document) {
    const event = document.createEvent('HTMLEvents');
    event.initEvent(eventName, false, true);
    element.dispatchEvent(event);
  } else {
    element.fireEvent(eventName);
  }
};
export const getElementPositionInContainer = (element, container) => {
  const elementRect = element.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();
  return {
    left: elementRect.left - containerRect.left + container.scrollLeft,
    top: elementRect.top - containerRect.top + container.scrollTop
  };
};
export const isInViewport = (element, additionalMargin) => {
  const $header = document.querySelector('.bp-page-header');
  const headerOffsetHeight = $header.offsetHeight;
  const navHeight = headerOffsetHeight + additionalMargin;
  const rect = element.getBoundingClientRect();
  const {
    offsetHeight,
    offsetWidth
  } = element;
  const clientHeight = window.innerHeight || document.documentElement.clientHeight;
  const clientWidth = window.innerWidth || document.documentElement.clientWidth;
  return rect.top >= -offsetHeight + navHeight && rect.left >= -offsetWidth && rect.bottom <= clientHeight + offsetHeight + navHeight && rect.right <= clientWidth + offsetWidth;
};
export const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);